// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DigitalpaymentReturnDetails {
    static getAttributeTypeMap() {
        return DigitalpaymentReturnDetails.attributeTypeMap;
    }
}
DigitalpaymentReturnDetails.discriminator = undefined;
DigitalpaymentReturnDetails.additionalProperties = false;
DigitalpaymentReturnDetails.attributeTypeMap = [
    {
        "name": "returnAmount",
        "baseName": "returnAmount",
        "type": "number"
    },
    {
        "name": "returnDate",
        "baseName": "returnDate",
        "type": "Date"
    },
    {
        "name": "returnReasonCode",
        "baseName": "returnReasonCode",
        "type": "string"
    },
    {
        "name": "returnReasonDescription",
        "baseName": "returnReasonDescription",
        "type": "string"
    },
];
//# sourceMappingURL=digitalpaymentReturnDetails.js.map